<template>
	<div class="msg-analysis-video">
		<video controls="controls" width="260" height="200">
			<source :src="message" type="video/mp4"></source>
		</video>
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisVideo',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: ''
			}
		},
		methods:{
			format(){
				let message = this.msg.content
				if(message.indexOf('http') === -1){
					message = AppConfig.host + message
				}
				this.message = message
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-video video{
		display: block;
	}
</style>
